/**
 * message redux actions
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import {
    CLEAR_DIALOG_MESSAGE, CLEAR_MESSAGE, SHOW_DIALOG_MESSAGE, SHOW_MESSAGE
} from "./consts";


export const showMessageAction = (message) => ({
    type: SHOW_MESSAGE,
    message: message
});

export const clearMessageAction = () => ({
    type: CLEAR_MESSAGE
});

export const showDialogMessageAction = (title, message) => ({
    type: SHOW_DIALOG_MESSAGE,
    title: title,
    message: message
});

export const clearDialogMessageAction = () => ({
    type: CLEAR_DIALOG_MESSAGE
});